<template>
  <div class="order-details-body-bd d-flex justify-content-between">
    <label for="total" class="h5 fw-bold">Total</label>
    <span v-if="cart.voucher_info" class="h5 fw-bold">&#8369;
      {{
        cartTotal | currency
      }}</span>
    <span v-else-if="cart.cart_count != 0" class="h5 fw-bold">
      &#8369;
      {{
        cartTotal | currency
      }}
    </span>
    <span v-else class="h5 fw-bold">
      &#8369; 0.00
    </span>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: ["cart"],
  filters: {
    currency(value) {
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2
      }).format(Number.parseFloat(value).toFixed(2));
    },
  },
  computed: {
    ...mapState("estore", ["cartSpecialDiscount"]),
    ...mapGetters("estore", ["cartTotal"]),
  }
}
</script>
